import type { ToastPayload } from '@app/shared/types/toast'

import { escape } from 'lodash'

import {
  PANEL_SUCCESS_TOAST_DISMISS_MS,
  PANEL_TOAST_ID,
} from '@app/application/user-management/constants'
import { useToastStore } from '@app/shared/pinia/toast'

export default function usePanelToast(): (
  message: string,
  variant: ToastPayload['variant'],
  id?: string
) => void {
  const toastStore = useToastStore()

  return (message, variant, id = PANEL_TOAST_ID) =>
    toastStore.raiseToast({
      id,
      // `noHtml` drops a tag instead of showing it, so a name like "Ops <EU>"
      // would lose "<EU>". Escaping keeps it as text.
      message: escape(message),
      variant,
      size: 'md',
      actions: [],
      noHtml: true,
      // A warning or an error stays until the user has read it.
      ...(variant === 'success'
        ? { autoDismissAfter: PANEL_SUCCESS_TOAST_DISMISS_MS }
        : {}),
    })
}
